export default __webpack_public_path__ + "static/media/users.c726f38f.svg";